<script lang="ts">
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Subscription} from 'rxjs';
    import {unsubscribeAllSubscriptions} from 'shared/utils/observables-utils';
    import {getLocalization} from 'core/svelte-context/context';
    import {onDestroy, onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {states} from 'shared/constants/portaro.constants';
    import KpSearchHeader from '../kp-search-header/KpSearchHeader.svelte';
    import KpSearchResultInfo from '../kp-search-result-info/KpSearchResultInfo.svelte';
    import KpSearchFooter from '../kp-search-footer/KpSearchFooter.svelte';
    import KpSearchSideContent from '../kp-search-content-layouts/KpSearchSideContent.svelte';
    import KpSearchMainContent from '../kp-search-content-layouts/KpSearchMainContent.svelte';
    import KpSearchResultsExportButton from '../kp-search-footer/KpSearchResultsExportButton.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let searchManager: SearchManager<any>;

    const localize = getLocalization();

    $: lastSearch = searchManager.getLastSearch$();

    let loadingItems = false;
    let initialLoadComplete = false;
    let paginationDataSubscription: Subscription;

    onMount(() => {
        paginationDataSubscription = searchManager.getPagination().getPaginationData$().subscribe((data) => {
            if (initialLoadComplete) {
                return;
            }

            loadingItems = data.state.distantPage === states.PROCESSING;

            if (data.state.distantPage === states.NORMAL) {
                initialLoadComplete = true;
            }
        });
    });

    onDestroy(() => {
        unsubscribeAllSubscriptions(paginationDataSubscription);
    });
</script>

<div class="kp-search type-{$lastSearch?.type ?? ''}">
    {#if !initialLoadComplete && loadingItems}
        <KpLoadingBlock fillAvailableSpace size="md">
            <span class="text-muted">{localize(/* @kp-localization commons.LoadingInProgress */ 'commons.LoadingInProgress')}</span>
        </KpLoadingBlock>
    {:else}
        <div class="row">
            <div class="col-sm-8">
                <KpSearchHeader {searchManager}/>
                <KpSearchResultInfo {searchManager}/>
                <KpSearchMainContent {searchManager}/>
            </div>

            <div class="col-sm-4 side-panels">
                {#if exists($$slots['additional-side-content'])}
                    <slot name="additional-side-content"/>
                {/if}

                <KpSearchSideContent {searchManager}/>
            </div>
        </div>

        <KpSearchFooter {searchManager}>
            <KpSearchResultsExportButton availableExports={$lastSearch.availableExports}/>
        </KpSearchFooter>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .row {
        margin-bottom: 30px;
    }

    .side-panels {
        display: flex;
        flex-direction: column;
        gap: @spacing-ml;
    }

    :global {
        .kp-search .side-panels {
            & > :empty {
                display: none;
            }

            .panel {
                margin-bottom: 0;
            }
        }
    }
</style>